import { Component, OnDestroy, OnInit } from '@angular/core';
import { appUserCompanyNameSelector } from '@core/application';
import { Store } from '@ngrx/store';
import { isNil } from 'lodash';
import { filter, map, Observable, Subject } from 'rxjs';

@Component({
  selector: 'cp-logo',
  templateUrl: './cp-logo.component.html',
  styleUrls: ['./cp-logo.component.scss'],
})
export class CpLogoComponent implements OnInit, OnDestroy {
  destroy$: Subject<void> = new Subject();
  companyName$: Observable<string>;

  constructor(private store$: Store) {
    this.companyName$ = this.store$.select(appUserCompanyNameSelector).pipe(
      filter((user) => {
        return !isNil(user);
      }),
      map((v) => v!)
    );
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
